import {Component, OnInit} from "@angular/core";
import {Field} from '../models/field.model';

@Component({
	selector: "tig-form-dual-list",
	template: `
		<div
			class="form-group"
			[formGroup]="OBJ_form_group"
			[ngClass]="{'has-error': isInvalid()}">
			<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
                <span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
			<div class="col-lg-8">
				<tig-dual-list-box
					[formControlName]="OBJ_field_config.name"
					[disabled]="OBJ_field_config?.readonly"
					[source]="OBJ_field_config.options"
					[config]="OBJ_dual_list_config"
					(destinationChange)="selected($event)"
				></tig-dual-list-box>
				<div class="tig-hint" *ngIf="OBJ_field_config.note">
					<span>{{ OBJ_field_config.note|translate}}</span>
				</div>
                <tig-form-error [OBJ_form_control]="OBJ_form_group.get(OBJ_field_config.name)"></tig-form-error>
			</div>
		</div>
	`
})
export class FormDualListBoxComponent extends Field implements OnInit
{


	/**
	 * Attributes
	 */
	OBJ_dual_list_config = {
		key: 'id',
		display: 'title',
		order: 'order',
		orderDrag: true,
		filter: true,
		sort: true,
		sortAttr: '_order',
		type: 'sample2',
		format: {
			direction: 'left-to-right',
			draggable: true,
			translate: {
				buttons: {
					assign: 'oDualListbox.sAssign',
					assign_all: 'oDualListbox.sAssignAll',
					remove: 'oDualListbox.sRemove',
					remove_all: 'oDualListbox.sRemoveAll'
				},
				search: {
					available: 'oDualListbox.sFilterAvailable',
					confirmed: 'oDualListbox.sFilterConfirmed'
				},
				order: 'oDualListbox.sOrder'
			}
		}
	};


	/**
	 * Function > ngOnInit
	 * @return {any}
	 */
	ngOnInit(): void {} // end function ngOnInit


	/**
	 * Function > selected
	 * @param {object} ARR_values
	 */
	public selected(ARR_values): void {

		this.markAsDirtyAndTouched();
	} // end function selected


} // end class FormDualListBoxComponent
